import {ISearchBarProps, SearchBar} from '../search-bar'
import './style.css'

export function ToolBar(props: ISearchBarProps) {
  const {actions} = props

  return (
    <div className='tool-bar'>
      <SearchBar actions={actions} />
    </div>
  )
}
